class StoresEditor extends HTMLElement {
  constructor() {
    super();
    this.source = this.querySelector('#storesEditorSource');
    this.fetcher = this.querySelector('#storesEditorFetch');
    this.refresher = this.querySelector('#storesEditorRefresh');
    this.content = this.querySelector('.stores-editor__content');
    this.actions = this.querySelector('.stores-editor__actions');
    this.controls = this.querySelector('.stores-editor__controls');
    this.add = this.querySelector('#storesEditorAdd');
    this.generate = this.querySelector('#storesEditorGenerate');
    this.update = this.querySelector('#storesEditorUpdate');

    this.inputVariables = ['name','address','zip','city','lat','lng'];

    this.index = 0;
    this.storesCount = 0;
    this.counter = this.querySelector('#storesCount');

    this.setupEventListeners();
  }  

  setupEventListeners() {
    this.fetcher.addEventListener('click', this.checkURL.bind(this));
    this.add.addEventListener('click', this.createRow.bind(this, ''));
    this.generate.addEventListener('click', this.generateJson.bind(this));
    this.refresher.addEventListener('click', this.refreshContent.bind(this));
  }

  setAttributes(element, attributes) {
    for(let key in attributes) {
      element.setAttribute(key, attributes[key]);
    }
  }

  updateCounter(correction) {
    setTimeout(() => { 
      this.storesCount = this.storesCount + correction;
      this.counter.innerHTML = `<span class="text-impact">${this.storesCount} ${window.storesEditor.stores_found}</span>`;
    }, 100);
  }

  // remove store line
  removeLine(target) {
    const container = document.createElement('div'),
          span = document.createElement('span'),
          validate = document.createElement('button'),
          cancel = document.createElement('button');

    container.setAttribute('class', 'remove-line');
    span.textContent = window.storesEditor.confirm_delete;
    span.setAttribute('class', 'text-impact');

    validate.innerHTML = window.storesEditor.icon_true;
    this.setAttributes(validate, {'class': 'validate', 'title': window.storesEditor.yes});
    validate.addEventListener('click', () => { 
      document.querySelector(`#${target}`).remove();
      this.updateCounter(-1);
     });
    
    cancel.innerHTML = window.storesEditor.icon_false;
    this.setAttributes(cancel, {'class': 'cancel', 'title': window.storesEditor.no});
    cancel.addEventListener('click', () => { document.querySelector(`#${target} .remove-line`).remove(); });

    [span,validate,cancel].forEach((elt) => {
      container.insertAdjacentElement('beforeend', elt);
    });
    document.querySelector(`#${target}`).insertAdjacentElement('beforeend', container);
  }

  // add a store line
  // for new line, store == '', getting store data otherwise
  createRow(store) {
    const div = document.createElement('div'),
          buttons = ['edit','geocode','delete'],
          rowsLength = document.querySelectorAll('.stores-editor__store-line').length,
          index = this.index,
          geolocated = store.lat != undefined && store.lng != undefined && store.lat != 'undefined' && store.lng != 'undefined' ? true : false;

    this.setAttributes(div, {
      'id': `row--${index}`,
      'class': 'stores-editor__store-line'
    });

    this.inputVariables.forEach((variable) => {
      const input = document.createElement('input');

      this.setAttributes(input, {
        'name': `${variable}`,
        'placeholder': window.storesEditor[`field_${variable}`]
      });
      if (store != '') {
        input.setAttribute('value', store[variable]);
        if (geolocated == true) input.disabled = true;
      };
      if (variable == 'lat' || variable == 'lng') input.setAttribute('type', 'hidden');
      div.insertAdjacentElement('beforeend', input);
    });

    buttons.forEach((button) => {
      const btn = document.createElement('button'),
            targetId = `row--${index}`;
      this.setAttributes(btn, {'class': `line-${button}`, 'target': targetId, 'title': window.storesEditor[`button_${button}`]});
      btn.innerHTML = window.storesEditor[`icon_${button}`];
      btn.addEventListener('click', (e) => {
        if (button == 'delete') this.removeLine(e.target.getAttribute('target'));
        if (button == 'edit') this.unlock(e.target.getAttribute('target'));
        if (button == 'geocode') this.getStoreValues(e.target.getAttribute('target'));
      });
      if (button == 'edit' && geolocated == false) btn.disabled = true;
      if (button == 'geocode' && geolocated == true) btn.disabled = true;
      div.insertAdjacentElement('beforeend', btn);
    })
    
    if (geolocated == true) {
      this.updateCounter(1);
      div.classList.add('geocoded');
    }
    
    this.content.insertAdjacentElement('beforeend', div);
    this.content.scrollTop = this.content.scrollHeight;
    this.index++;
  }

  refreshContent() {
    const container = document.createElement('div'),
          span = document.createElement('span'),
          validate = document.createElement('button'),
          cancel = document.createElement('button');

    this.content.classList.add('busy');

    container.setAttribute('class', 'refresh-content');
    span.textContent = window.storesEditor.confirm_refresh;
    span.setAttribute('class', 'text-impact');
    
    validate.innerHTML = window.storesEditor.icon_true;
    this.setAttributes(validate, {'class': 'validate', 'title': window.storesEditor.yes});
    validate.addEventListener('click', () => { 
      this.content.innerHTML = '';
      this.storesCount = 0;
      this.content.classList.remove('busy');
      this.checkURL();
     });
    
    cancel.innerHTML = window.storesEditor.icon_false;
    this.setAttributes(cancel, {'class': 'cancel', 'title': window.storesEditor.no});
    cancel.addEventListener('click', () => { 
      this.content.querySelector('.refresh-content').remove();
      this.content.classList.remove('busy');
     });

    [span,validate,cancel].forEach((elt) => {
      container.insertAdjacentElement('beforeend', elt);
    });
    this.content.insertAdjacentElement('beforeend', container);
    container.focus();
  }

  checkURL() {
    const sourcePath = this.source.value,
          http = new XMLHttpRequest();
    http.open('HEAD', sourcePath, false);
    http.send();
    if (http.status != 404) {
      this.openJson(sourcePath);
    } else {
      this.displayNotification(`<p>${window.storesEditor.unknown_file}</p>`)
    }
  }

  openJson(source) {
    const interval = 2;
    let sourceHeaders = new Headers();
    sourceHeaders.append('pragma', 'no-cache');
    sourceHeaders.append('cache-control', 'no-cache');

    let sourceInit = {
      method: 'GET',
      headers: sourceHeaders,
    };

    fetch(source, sourceInit)
      .then(response => response.json())
      .then(json => {
        json.forEach((row, index) => {
          setTimeout(() => { this.createRow(row); }, index * interval);
        })
        this.controls.classList.remove('hidden');
        this.actions.classList.remove('hidden');
        this.refresher.disabled = false;
        this.fetcher.disabled = true;
      })
  }

  unlock(target) {
    const tgt = document.querySelector(`#${target}`);
    tgt.classList.remove('geocoded');
    tgt.querySelectorAll('input').forEach((input) => { input.disabled = false; });
    tgt.querySelector('.line-geocode').disabled = false;
    tgt.querySelector('.line-edit').disabled = true;
    this.updateCounter(-1);
  }

  getStoreValues(target) {
    const line = document.querySelector(`#${target}`);
    let store = {};
    this.inputVariables.forEach((variable) => {
      store[variable] = line.querySelector(`input[name="${variable}"]`).value;
    });
    setTimeout(() => {
      this.geocode(store, target);
    }, 500);
  }

  geocode(store, target) {
    const geocodeAPI = (address) => {
            return window.storesEditor.geocode_url + address;
          },
          fullAddress = (store) => {
            return `${store.address}, ${store.zip} ${store.city}`;
          };

    fetch(geocodeAPI(encodeURI(fullAddress(store))))
      .then( response => response.json())
      .then( data => {
        store.lat = data.results[0].geometry.lat;
        store.lng = data.results[0].geometry.lng;
      })
      .then(() => {
        if (store.lat != undefined && store.lng != undefined) {
          const tgt = document.querySelector(`#${target}`);
          tgt.classList.add('geocoded');
          tgt.querySelector('input[name="lat"]').value = store.lat;
          tgt.querySelector('input[name="lng"]').value = store.lng;
          tgt.querySelectorAll('input').forEach((input) => { input.disabled = true; });
          tgt.querySelector('.line-geocode').disabled = true;
          tgt.querySelector('.line-edit').disabled = false;

          this.updateCounter(1);
        }
      })
      .catch((error) => {
        console.log(error)
      });
  }

  // generate JSON
  generateJson() {
    const storesArray = [],
          storeLines = document.querySelectorAll('.stores-editor__store-line.geocoded');

    storeLines.forEach((line, index) => {
      let store = {};
      store.id = index + 1;
      store.name = line.querySelector('input[name="name"]').value;
      store.address = line.querySelector('input[name="address"]').value;
      store.zip = line.querySelector('input[name="zip"]').value;
      store.city = line.querySelector('input[name="city"]').value;
      store.lat = line.querySelector('input[name="lat"]').value;
      store.lng = line.querySelector('input[name="lng"]').value;
      storesArray.push(store);
    });
    this.sortJson(storesArray);
  }

  // sort JSON
  // sort stores array by city
  sortJson(array) {
    let sortedArray = array.sort((a, b) => {
          const cityA = a.city,
                cityB = b.city;

          return cityA.localeCompare(cityB, 'fr', {sensitivity: 'base'});
        });
    this.downloadJson(sortedArray);
  }

  // download JSON
  downloadJson(array) {
    const a = document.createElement('a'),
          content = JSON.stringify(array),
          file = new Blob([content], { type: 'text/plain' }),
          now = new Date(),
          month = now.getMonth() + 1,
          mm = `${month < 10 ? '0' + month : month}`,
          dd = `${now.getDate() < 10 ? '0' + now.getDate() : now.getDate()}`,
          hh = `${now.getHours() < 10 ? '0' + now.getHours() : now.getHours()}`,
          mn = `${now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()}`,
          ss = `${now.getSeconds() < 10 ? '0' + now.getSeconds() : now.getSeconds()}`,
          nowDate = `${now.getFullYear() + mm + dd + hh + mn + ss}`,
          fileName = `elvish-store-list-${nowDate}.json`;
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
  }
}  
customElements.define('stores-editor', StoresEditor);
